import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import About from './pages/About';
import Contact from './pages/Contact';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import GemPortal from './pages/GemPortal';
import Advantages from './pages/Advantages';
import Resources from './pages/Resources';
import Dealers from './pages/Dealers';
import OtherProducts from './pages/OtherProducts';
import AdminApp from './admin/AdminApp';
import { AppProvider, useAppData } from './AppContext';
import WhatsAppFloat from './components/WhatsAppFloat';
import './App.css';

// Pages hidden from the public site when their nav item is disabled.
// Direct visits to these routes redirect home so the pages can't be reached or indexed.
const makeGuarded = (href, Page) => () => {
  const { navItems } = useAppData();
  const item = (navItems || []).find(n => n.href === href);
  if (!item || item.disabled) return <Navigate to="/" replace />;
  return <Page />;
};
const GuardedDealers       = makeGuarded('/dealers',        Dealers);
const GuardedOtherProducts = makeGuarded('/other-products', OtherProducts);

function App() {
  const [cartItems, setCartItems] = useState([]);
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem('prabhjot-theme') === 'dark';
  });

  useEffect(() => {
    AOS.init({ duration: 750, once: true, easing: 'ease-out-cubic', offset: 60 });
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
    localStorage.setItem('prabhjot-theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  const toggleDark = () => setDarkMode(d => !d);

  const removeFromCart = (productId) => {
    setCartItems(cartItems.filter(item => item.id !== productId));
  };

  const cartCount = cartItems.length;

  return (
    <AppProvider>
      <Router>
        <Routes>
          {/* Admin panel – standalone, no Navbar/Footer */}
          <Route path="/admin/*" element={<AdminApp />} />

          {/* Main website */}
          <Route path="*" element={
            <div className="App">
              <Navbar cartCount={cartCount} darkMode={darkMode} toggleDark={toggleDark} />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/product/:id" element={<ProductDetail />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/advantages" element={<Advantages />} />
                  <Route path="/resources" element={<Resources />} />
                  <Route path="/dealers" element={<GuardedDealers />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/gem-portal" element={<GemPortal />} />
                  <Route path="/cart" element={<Cart cartItems={cartItems} removeFromCart={removeFromCart} />} />
                  <Route path="/other-products" element={<GuardedOtherProducts />} />
                </Routes>
              </main>
              <Footer />
              <WhatsAppFloat />
            </div>
          } />
        </Routes>
      </Router>
    </AppProvider>
  );
}

export default App;
